import { captureException } from "@sentry/react";

// this is only ever needed for useEffect, edge cases; kept it just in case
export let backoffTimeoutId: ReturnType<typeof setTimeout>;

export const callWithExponentialBackoff = async <T>(
  asyncAction: () => Promise<T>,
  maxRetries = 4,
  initialDelay = 2222,
) =>
  new Promise<T>((resolve, reject) => {
    const retry = (attempt: number) => {
      asyncAction()
        .then(resolve)
        .catch((error: Error) => {
          captureException(error, {
            tags: {
              caller: "callWithExponentialBackoff",
              attempt,
            },
          });

          if (attempt < maxRetries) {
            const delay = initialDelay * Math.pow(2, attempt);

            backoffTimeoutId = setTimeout(() => {
              retry(attempt + 1);
            }, delay);
          } else {
            reject(error);
          }
        });
    };

    retry(0);
  });
